import React from 'react';
import './Home.css';
import Header from '../Header/Header.js';
import QuemSomos from '../QuemSomos/QuemSomos.js';
import Servicos from '../Servicos/Servicos.js';
import Contador from '../Contador/Contador.js';
import Clientes from '../Clientes/Clientes.js';
import Equipe from '../Equipe/Equipe.js';
import Projetos from '../Projetos/Projetos.js';
import Contato from '../Contato/Contato.js';
import Depoimentos from '../Depoimentos/Depoimentos.js';

export default function Home() {
  return (
    <div className="">
      <Header />
      <QuemSomos />
      <Servicos />
      <Contador/>
      <Clientes />
      <Depoimentos />
      <Equipe />
      <Projetos />
      <Contato />
    </div>
  );
}